<template>
	<div>
		<modal v-if="(showVideoModal === false)" class="product-dropship-modal" size="full" @close="$emit('close')">
			<div slot="body">
				<div class="modal-header mb-3">
					<span>{{ category }}</span>
					<button type="button" class="close" aria-label="Close" @click="$emit('close')">
						<i class="bi bi-x-lg"></i>
					</button>
				</div>
				<hr />
				<div class="container-fliud">
					<div class="text-center">
						<div class="spinner-border" v-if="isLoadingDetail" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</div>
					<div class="wrapper row" v-if="!isLoadingDetail">
						<div class="col-md-5 p-0">
							<div class="px-4">
								<VueSlickCarousel ref="carouselmain" v-bind="carouselMain"
									@beforeChange="onBeforeChangeMain">
									<div v-for="(picture, index) in product.pictures" :key="index">
										<img :src="picture" class="img-main" />
									</div>
									<div v-if="(youtubeThumb(videos[0]) != '')" :key="getIndexOfVideo">
										<img :src="youtubeThumb(videos[0])" class="img-main" />
									</div>
								</VueSlickCarousel>
							</div>
							<div class="px-4">
								<VueSlickCarousel ref="carouselthumb" v-bind="carouselControl"
									@beforeChange="onBeforeChangeThumb">
									<div class="img-thumb-box" v-for="(picture, index) in product.pictures" :key="index">
										<img :src="picture" class="img-thumb" />
									</div>
									<div class="img-thumb-box" v-if="(youtubeThumb(videos[0]) != '')" :key="getIndexOfVideo">
										<img :src="youtubeThumb(videos[0])" class="img-thumb" @click="showVideo(true)" />
									</div>
								</VueSlickCarousel>
							</div>
						</div>
						<div class="details col-md-7">
							<h3 class="product-title">{{ product.name }}</h3>
							<div class="product-aggregate d-flex justify-content-between" ref="productAggregate">
								<li class="first-aggregate">Rekomendasi Harga Jual <span>{{ sellPrice }}</span></li>
								<li>Berat <span>{{ weight }}gr</span></li>
								<li>Stok <span>{{ getStockQuantity(product) }}</span></li>
								<li>Dikirim dari <span>{{ getShippingOrigin(product) }}</span></li>
							</div>
							<badges class="mt-1" :is-cod-enabled="isCODEnabled" :is-lp-enabled="isLpEnabled" :is-marketing-kit-enabled="isMarketingKitEnabled" :is-private-enabled="product.visibility && product.visibility === 'private'"></badges>
							<h4 class="price mb-0">Harga Jual: <span>{{ sellPrice }}</span></h4>
							<!-- Buy Price without sale price -->
							<!-- <div class="capital-price">Harga modal : <span class="text-bold">{{ buyPrice }}</span></div> -->

							<!-- Buy Price with sale price -->
							<div class="capital-price">
								<div>Harga modal :</div>
								<span class="text-bold">{{ originalBuyPrice }}</span>
								<div class="d-flex align-items-center">
									<span
										class="sale-price"
										:class="{ 'invisible': !hasSalePrice }"
									>
										{{ buyPrice }}
									</span>
									<span
										class="badge badge-danger ml-1 percent-off"
										v-if="percentOff !== '-' && percentOff !== '0%'"
									>
										{{ percentOff }}
									</span>
								</div>
							</div>
							<div class="capital-price" v-if="!isDropshipper">Harga supplier : <span class="text-bold">{{ supplierPrice }}</span></div>
							<span class="divider mt-3 mb-3"></span>
							<!-- <div class="detail-title">Kategori <span class="text-bold">{{ category }}</span></div>
							<div class="detail-title">Berat <span class="text-bold">{{ weight }}gr</span></div>
							<div v-if="product.stock.enabled" class="detail-title">Stock <span class="text-bold">{{ getStockQuantity(product) }}</span></div>
							<div class="detail-title">SKU <span class="text-bold">{{ product.code }}</span></div>
							<div class="detail-title">Dikirim Dari <span class="text-bold">{{ supplierAddress }}</span></div>
							<div class="detail-title">COD Config <span class="text-bold">{{ checkCOD(product.payments) }}</span></div>
							<div class="detail-title">Service Courier <span class="text-bold">{{ showServices(product) }}</span></div>
							<div class="detail-title">Courier Active
								<img
									v-for="item in product.shipping.couriers"
									:key="item"
									class="img-fluid mx-1"
									width="40"
									height="40"
									:src="'/images/logo-' + item + '.png'"
								/>
							</div>
							<span class="divider mt-3 mb-3"></span> -->
							<div class="product-variations"
								v-if="product && product.type === 'variable' && productVariations && productVariations.prices && productVariations.prices.length > 0">
								<div class="row">
									<div class="col-12">
										<span class="variant-info text-right text-bold" for="HB">Variant</span>
									</div>
									<div class="col-12">
										<span class="variant-info text-right" for="HB"><strong>HM :</strong> Harga Modal</span>
										<span class="variant-info text-right mx-2" for="HJ"><strong>HJ :</strong> Harga Jual</span>
										<span class="variant-info text-right mx-2" for="HJ" v-if="!isDropshipper"><strong>HS :</strong> Harga Supplier</span>
									</div>
								</div>
								<div class="row table-responsive">
									<span class="divider mt-3 mb-3"></span>
									<table
										class="variant-table table table-striped table-hover mt-2"
									>
										<thead>
											<tr>
												<th v-if="productVariations.table.type !== 'single'"></th>
												<th v-for="(item, idx) in productVariations.table.field" :key="idx" :class="{ 'hidden': isAllColumnNull(item) }">
													{{ item }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(items, index) in productVariations.table.data" :key="index" :class="{ 'hidden': isAllRowNull(index) }">
												<td v-if="productVariations.table.type !== 'single'" class="text-center align-middle multiple-variant">
													<strong>{{index}}</strong>
												</td>
												<td v-for="(price, key, idx) in items" :key="idx" :class="{ 'hidden': isAllDataNull(key) }">
													<div :class="{ 'invisible': !isVariationEnabled(index, key) }">
														<div>
															<span>HM : </span>
															<span v-if="!isVariationEnabled(index, key)">-</span>
															<span v-else>{{ getBuyPrice(price, getOutsourceCommissionVariation(index, key), false) }}</span> <!-- Buy Price Without Commission -->
															<!-- <span v-else>{{ getBuyPrice(price, getOutsourceCommissionVariation(index, key)) }}</span> --> <!-- Buy Price With Commission -->
														</div>
														<div>
															<span>HJ : </span>
															<span v-if="!isVariationEnabled(index, key)">-</span>
															<span v-else>{{ getSellPrice(price, getMarginVariation(index, key), getOutsourceCommissionVariation(index, key), false) }}</span>
														</div>
														<div v-if="!isDropshipper">
															<span>HS : </span>
															<span v-if="!isVariationEnabled(index, key)">-</span>
															<span v-else>{{ getSupplierPrice(price) }}</span>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="mt-4">
								<nav ref="nav">
									<div class="nav nav-tabs" id="nav-tab" role="tablist">
										<a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#detailTab" @click="assignActiveTab('detailTab')" role="tab" aria-controls="nav-home" aria-selected="true">Detail</a>
										<a v-if="isShowMarketingKit || isShowMarketingKits" class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" href="#merketingTab" @click="assignActiveTab('merketingTab')" role="tab" aria-controls="nav-home" aria-selected="true">Marketing Kit</a>
										<a v-if="isHasPage" class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" href="#previewTab" role="tab" @click="assignActiveTab('previewTab')" aria-controls="nav-home" aria-selected="true">Preview Landing Page</a>
									</div>
								</nav>
								<div class="tab-content" id="nav-tabContent">
									<div class="tab-pane fade show active py-4" id="detailTab" role="tabpanel" aria-labelledby="nav-home-tab">
										<!-- Description -->
										<div class="description" :class="readMore">
											<p v-html="sanitizeHtml(product.description)" ref="description"></p>
										</div>
									</div>
									<div v-if="isShowMarketingKit || isShowMarketingKits" class="tab-pane fade show py-4" id="merketingTab" role="tabpanel" aria-labelledby="nav-home-tab">
										<div class="multi" v-if="isShowMarketingKits">
											<div v-for="item in product.marketing_kit" :key="item.content_code">
												<p v-html="sanitizeHtml(item.description)" ref="description"></p>
												<button class="btn btn-sm btn-primary" target="_blank" @click="downloadMarketingKit(item.content_code)"><strong>Download</strong> </button>
											</div>
										</div>
										<div class="single" v-else>
											<p v-html="sanitizeHtml(product.marketing_kit.description)" ref="description"></p>
											<!-- <button class="btn btn-sm btn-primary" target="_blank" @click="downloadMarketingKit(product.marketing_kit.content_code)"><strong>Download</strong> </button> -->
											<a target="_blank" :href="product.marketing_kit.link" class="mr-2 btn btn-sm btn-primary"><strong>Download</strong> </a>
										</div>
									</div>
									<div v-if="isHasPage" class="tab-pane fade show py-4" id="previewTab" role="tabpanel" aria-labelledby="nav-home-tab">
										<div v-for="(page, index) in product.pages" :key="index">
											<div class="d-flex justify-content-between mb-3">
												<a target="_blank" :href="page.url" class="mr-2"><strong>{{ page.type.label }}</strong> </a>
												<a target="_blank" :href="page.url" class="btn btn-primary btn-detail">
													<div v-if="page.type.value === 'orderonline'">
														<i class="material-icons">content_copy</i>
														Duplicate
													</div>
													<div v-else>
														<i class="material-icons">download</i>
														Download
													</div>
												</a>
											</div>

											<div class="d-flex justify-content-end" v-for="(preview, i) in page.previews" :key="i">
												<a target="_blank" :href="preview.url">
													<span class="link-preview d-flex align-items-center">
														{{ preview.title }} <i class="ml-1 material-icons link-preview">launch</i>
													</span>
												</a>
											</div>
										</div>
									</div>
								</div>
								<transition name="fade">
									<span class="text-primary description-toggle" v-if="product.description && isDetailTabActive" @click="toggleDescription">{{ toggleDescriptionLabel }}</span>
								</transition>
								<hr>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="$emit('close')">
					{{ $t('_.close') }}
				</button>
			</div>
		</modal>

		<modal v-if="(showVideoModal === true)" class="product-dropship-modal" size="large" @close="$emit('close')">
			<div slot="body">
				<div class="container-fliud">
					<div class="wrapper row mt-4">
						<div class="col-md-12">
							<h4 class="product-title">{{ product.name }}</h4>
						</div>
						<div class="col-md-12">
							<div class="embed-responsive embed-responsive-16by9">
								<iframe class="embed-responsive-item" :src="videoEmbedUrl(videos[0])"
									allowfullscreen></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="showVideo(false)">
					{{ $t('_.close') }}
				</button>
			</div>
		</modal>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import {
	formatMoney,
	getYoutubeThumb,
	getYoutubeId,
	getDropshipFinalPrice,
	getProductPricePlusCommission,
	getIsDiscounted,
	getSalePrice,
	getWholesalePrice,
	getOstockCommissionValue,
	sanitizeHtml,
	formatNumberPlain,
	downloadFile,
	getAxiosErrorMessage,
	toTitleCase,
	getDropshipVariationFinalPrice,
	getSimpleProductOriginalPrice,
	calculateDiscount,
	getMinMaxValue,
	getVariableCommisionValue,
	getShippingOrigin,
	duplicateVar,
} from '@/lib/helper';
import {
	shippingServices,
} from '@/lib/statics';
import productContentApi from '@/api/product-content';
import {
	// getCommissionValue,
	elipsisPrice,
	getMarginValue,
} from '@/lib/product';
import Modal from '@/components/Modal.vue';
import Badges from '@/components/products/Badges.vue';

export default {
	name: 'ProductItemDetail',
	props: {
		product: {
			type: Object,
			default() { },
		},
		max: {},
		format: {
			type: String,
			default: 'int', // int, float
		},
		isDetailSeller: {
			type: Boolean,
			default: false,
		},
		isLoadingDetail: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		Modal,
		VueSlickCarousel,
		Badges,
	},
	data() {
		return {
			isLoading: false,
			carouselMain: {
				arrows: false,
				asNavFor: this.$refs.carouselthumb,
				focusOnSelect: true,
			},
			carouselControl: {
				arrows: true,
				asNavFor: this.$refs.carouselmain,
				slidesToShow: 5,
				focusOnSelect: true,
			},
			videos: this.product.videos || [''],
			showVideoModal: false,
			readMore: 'read-less',
			descriptionHeight: 0,
			activeTab: 'detailTab',
			isDescriptionExpanded: false,
		};
	},
	methods: {
		downloadFile,
		getMarginValue,
		toTitleCase,
		getMinMaxValue,
		downloadMarketingKit(link) {
			this.isDownloading = true;
			const params = {
				content_code: link,
			};
			const callback = (response) => {
				this.isDownloading = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);

				this.isDownloading = false;
				this.$notify({
					group: 'product_contents',
					title: 'Marketing Kit',
					text: msg,
					type: 'error',
				});
			};

			productContentApi.download(params, callback, errorCallback);
		},
		assignActiveTab(tab) {
			this.activeTab = tab;
		},
		showServices(product) {
			let service = '';
			const services = product?.shipping?.services ?? [];
			if (services.length > 0) {
				services.forEach((element, index) => {
					const shippingService = shippingServices.find(obj => obj.value === element);
					service += `${toTitleCase(shippingService.label.replace('_', ' '))}`;

					if (index + 1 !== services.length) {
						service += ', ';
					}
				});
			}

			return service;
		},
		showCouriers(couriers) {
			if (couriers.length > 0) {
				return couriers.join(', ');
			}

			return '';
		},
		checkCOD(payments) {
			const isCOD = payments.filter(payment => payment === 'cod');

			return isCOD.length > 0 ? 'Active' : 'Disabled';
		},
		getMarginVariation(key1, key2) {
			let marginValue = 0;
			if (this.productVariations?.table?.margin) {
				marginValue = this.productVariations?.table?.margin[key1][key2] ?? 0;
			}
			return marginValue;
		},
		getOutsourceCommissionVariation(key1, key2) {
			let oursourceCommision = 0;
			if (this.productVariations?.table?.outsource_commission) {
				oursourceCommision = this.productVariations?.table?.outsource_commission[key1][key2] ?? {};
			}
			return oursourceCommision;
		},
		getBuyPrice(price, outsourceCommission = {}, withCommission = true) {
			const productVariant = this.filterById(this.product?.variations?.prices, outsourceCommission?.variant_id);

			let commission = 0;
			if (productVariant && withCommission) {
				commission = getVariableCommisionValue(productVariant[0], this.product);
			}
			// // const comission = getCommissionValue(price, this.product.commission_percentage);
			// // const comission = getOstockCommissionValue(this.product, price);
			const pricePlusCommission = price + commission;
			return this.user ? formatMoney(pricePlusCommission) : elipsisPrice(pricePlusCommission);
		},
		getSellPrice(productPrice, margin = 0, outsourceCommission = {}, withCommission = true) {
			// const comission = getCommissionValue(productPrice, this.product.commission_percentage);
			// const comission = getOstockCommissionValue(this.product, productPrice);
			const productVariant = this.filterById(this.product?.variations?.prices, outsourceCommission?.variant_id);
			// const comission = getCommissionValue(productPrice, this.product.commission_percentage);
			let commission = 0;
			if (productVariant.length > 0 && withCommission) {
				commission = getVariableCommisionValue(productVariant[0], this.product);
			} else if (withCommission) {
				commission = getVariableCommisionValue({}, this.product);
			}

			if (margin === 0) {
				margin = getMarginValue(productPrice, this.product.dropship.margin, this.product.dropship.type);
			}

			const isOnDiscount = getIsDiscounted(this.product);
			const salePrice = getSalePrice(this.product);
			const wholesales = this.product.wholesale || [];
			const normalPrice = isOnDiscount ? salePrice : productPrice;
			const price = getWholesalePrice(wholesales, 1, normalPrice);

			const finalPrice = price + margin + commission;
			return formatMoney(finalPrice);
		},
		getSupplierPrice(price) {
			return formatMoney(price);
		},
		getStockQuantity(product) {
			const isSimple = product.type === 'simple';
			const quantity = isSimple ? product.stock.quantity : product.variations.prices.reduce((prevQty, variation) => {
				const variationQuantity = variation.stock ? variation.stock.quantity : 0;
				const totalQuantity = prevQty + variationQuantity;
				return totalQuantity;
			}, 0);
			return quantity;
		},
		youtubeThumb(url) {
			const vidUrl = url || '';
			return getYoutubeThumb(vidUrl);
		},
		showVideo(state) {
			this.showVideoModal = state;
		},
		videoEmbedUrl(videoUrl) {
			const videoId = getYoutubeId(videoUrl);
			return `https://www.youtube.com/embed/${videoId}`;
		},
		formatMoney(price) {
			return formatMoney(price);
		},
		onBeforeChangeThumb(currentPosition, nextPosition) {
			this.$refs.carouselmain.goTo(nextPosition);
		},
		onBeforeChangeMain(currentPosition, nextPosition) {
			this.$refs.carouselthumb.goTo(nextPosition);
		},
		getBasePriceSeller() {
			const cogs = parseInt(this.product?.dropship?.original_price ?? this.product?.cogs);
			// const commissionPercentage = this.product?.commission_percentage ?? 5;
			// const commissionValue = commissionPercentage / 100 * cogs;
			const commissionValue = getOstockCommissionValue(this.product, cogs);
			const basePrice = cogs + commissionValue;
			return this.formatMoney(basePrice);
		},
		sanitizeHtml,
		toggleDescription() {
			this.isDescriptionExpanded = !this.isDescriptionExpanded;

			if (this.isDescriptionExpanded) {
				this.readMore = '';
			} else {
				this.readMore = 'read-less';
			}
		},
		getVariableCommisionValue,
		filterById(array, id) {
			return array.filter(item => item.id === id);
		},
		getShippingOrigin,
		isVariationEnabled(secondVariationName, firstVariationName) {
			let variantName = firstVariationName;
			if (this.productVariations.table.type !== 'single') {
				variantName = `${firstVariationName}||${secondVariationName}`;
			}
			const selectedVariant = this.productVariations?.prices?.find(variant => variant?.name === variantName);

			if (typeof selectedVariant?.enabled !== 'undefined' && !selectedVariant?.enabled) {
				return false;
			}

			return true;
		},
		isAllColumnNull(firstVariationName) {
			const itemCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] !== undefined ? total + 1 : total), 0);
			const nullCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] === null ? total + 1 : total), 0);

			return nullCounter === itemCounter;
		},
		isAllDataNull(firstVariationName) {
			const itemCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] !== undefined ? total + 1 : total), 0);
			const nullCounter = Object.keys(this.tableData).reduce((total, variant) => (this.tableData[variant][firstVariationName] === null ? total + 1 : total), 0);

			return nullCounter === itemCounter;
		},
		isAllRowNull(secondVariationName) {
			const itemCounter = Object.keys(this.tableData[secondVariationName]).length;
			const nullCounter = Object.values(this.tableData[secondVariationName]).filter(value => value === null).length;

			return nullCounter === itemCounter;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isDropshipper: 'isDropshipper',
		}),
		getBasePriceRegular() {
			const pricePlusCommission = getProductPricePlusCommission(this.product);
			const price = formatNumberPlain(pricePlusCommission);
			const splittedPrice = price.split('.');
			let censoredPrice = '';
			splittedPrice.forEach((val, index) => {
				if (index === 0) {
					censoredPrice += 'X'.repeat(val.length);
				} else {
					censoredPrice += `.${val}`;
				}
			});
			return `Rp${(this.user ? price : censoredPrice)}`;
		},
		supplierPriceRegular() {
			const pricePlusSupplier = this.product?.price ?? 0;
			const price = formatNumberPlain(pricePlusSupplier);

			return `Rp${price}`;
		},
		basePriceRange() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false);
			let firstPrice = null;
			let secondPrice = null;
			(variations.prices).forEach((element) => {
				if (firstPrice == null) {
					firstPrice = element.price;
				} else if (firstPrice > element.price) {
					firstPrice = element.price;
				}
				if (secondPrice == null) {
					secondPrice = element.price;
				} else if (secondPrice < element.price) {
					secondPrice = element.price;
				}
			});

			const formattedFirstPrice = !this.user ? elipsisPrice(firstPrice) : formatMoney(firstPrice);
			const formattedSecondPrice = !this.user ? elipsisPrice(secondPrice) : formatMoney(secondPrice);

			const price = firstPrice !== secondPrice ? `${formattedFirstPrice} - ${formattedSecondPrice}` : formattedFirstPrice;

			return price;
		},
		supplierPriceRange() {
			const variations = this.product?.variations ?? {};
			const getPrice = this.getMinMaxValue(variations, 'price');
			const price = getPrice.minValue !== getPrice.maxValue ? `${formatMoney(getPrice.minValue)} - ${formatMoney(getPrice.maxValue)}` : formatMoney(getPrice.minValue);

			return price;
		},
		buyPrice() {
			return this.product.type === 'variable' ? this.basePriceRange : this.getBasePriceRegular;
		},
		hasSalePrice() {
			const originalPrice = this.originalBuyPrice;
			const salePrice = this.buyPrice;

			const isDifferent = originalPrice !== salePrice;

			if (!this.user) {
				return true;
			}

			return isDifferent;
		},
		originalBuyPrice() {
			return this.product.type === 'variable' ? this.originalPriceRange : this.originalPrice;
		},
		originalPriceRange() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false, false);
			let minPrice = null;
			let maxPrice = null;
			const variationPrices = variations?.prices ?? [];

			variationPrices.forEach((variation) => {
				const price = variation?.price ?? 0;

				if (minPrice === null || price < minPrice) {
					minPrice = price;
				}
				if (maxPrice === null || price > maxPrice) {
					maxPrice = price;
				}
			});

			const formattedMinPrice = !this.user ? elipsisPrice(minPrice) : formatMoney(minPrice);
			const formattedMaxPrice = !this.user ? elipsisPrice(maxPrice) : formatMoney(maxPrice);

			return minPrice !== maxPrice ? `${formattedMinPrice} - ${formattedMaxPrice}` : formattedMinPrice;
		},
		originalPrice() {
			const price = getSimpleProductOriginalPrice(this.product);
			return this.user ? formatMoney(price) : elipsisPrice(price);
		},
		simplePercentOff() {
			const pricePlusCommission = getProductPricePlusCommission(this.product);
			const originalPrice = getSimpleProductOriginalPrice(this.product);
			return this.user ? calculateDiscount(pricePlusCommission, originalPrice) : 'XX%';
		},
		variablePercentOff() {
			const variationsSalePrices = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false);
			const variationsOriginalPrices = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, false, false);

			let highestPercentOff = 0;

			const salePrices = variationsSalePrices?.prices ?? [];
			const originalPrices = variationsOriginalPrices?.prices ?? [];

			salePrices.forEach((variant, idx) => {
				const isVariantEnabled = variant?.enabled ?? true;
				if (!isVariantEnabled) return;

				const salePrice = variant?.price ?? 0;
				const originalPrice = originalPrices[idx]?.price ?? 0;

				const percentOff = calculateDiscount(salePrice, originalPrice, false);

				if (percentOff > highestPercentOff) {
					highestPercentOff = percentOff;
				}
			});

			return this.user ? `${highestPercentOff}%` : 'XX%';
		},
		percentOff() {
			return this.product.type === 'variable' ? this.variablePercentOff : this.simplePercentOff;
		},
		supplierPrice() {
			return this.product.type === 'variable' ? this.supplierPriceRange : this.supplierPriceRegular;
		},
		sellPrice() {
			return this.product.type === 'variable' ? this.dropshipFinalPriceRange : this.dropshipFinalPrice;
		},
		// dropshipFinalPriceRange() {
		// 	const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, !this.isOfficialSeller);
		// 	const getPrice = this.getMinMaxValue(variations, 'price');
		// 	const price = getPrice.minValue !== getPrice.maxValue ? `${formatMoney(getPrice.minValue)} - ${formatMoney(getPrice.maxValue)}` : formatMoney(getPrice.minValue);

		// 	return price;
		// },
		dropshipFinalPriceRange() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, !this.isOfficialSeller, false);
			let firstPrice = null;
			let secondPrice = null;
			(variations.prices).forEach((element) => {
				if (firstPrice == null) {
					firstPrice = element.price;
				} else if (firstPrice > element.price) {
					firstPrice = element.price;
				}
				if (secondPrice == null) {
					secondPrice = element.price;
				} else if (secondPrice < element.price) {
					secondPrice = element.price;
				}
			});

			const price = firstPrice !== secondPrice ? `${formatMoney(firstPrice)} - ${formatMoney(secondPrice)}` : formatMoney(firstPrice);

			return price;
		},
		weightSimple() {
			return this.product?.weight;
		},
		weightVariable() {
			const variations = getDropshipVariationFinalPrice(this.product, this.isOfficialSeller, !this.isOfficialSeller);
			const getWeight = this.getMinMaxValue(variations, 'weight');
			const weight = getWeight.minValue !== getWeight.maxValue ? `${getWeight.minValue} - ${getWeight.maxValue}` : getWeight.minValue;

			return weight;
		},
		weight() {
			return this.product.type === 'variable' ? this.weightVariable : this.weightSimple;
		},
		productVariations() {
			return this.product?.variations ?? {};
		},
		supplierAddress() {
			return `${this.product.shipping?.origin?.city_name}, ${this.product.shipping?.origin?.name}, ${this.product.shipping?.origin?.province_name}`;
		},
		category() {
			return this.product?.category?.category ?? '-';
		},
		toggleDescriptionLabel() {
			return this.isDescriptionExpanded ? 'Lihat Lebih Sedikit' : 'Lihat Selengkapnya';
		},
		isDetailTabActive() {
			return this.activeTab === 'detailTab';
		},
		isShowAddProduct() {
			return this.show;
		},
		getIndexOfVideo() {
			return this.product.pictures.length + 1;
		},
		basePrice() {
			return this.isDetailSeller ? this.getBasePriceSeller() : this.getBasePriceRegular();
		},
		// dropshipFinalPrice() {
		// 	let price = getDropshipFinalPrice(this.product);
		// 	if (this.isDetailSeller) {
		// 		price = this.product.price;
		// 	}
		// 	return this.formatMoney(price);
		// },
		dropshipFinalPrice() {
			return formatMoney(getDropshipFinalPrice(this.product, [], 1, true, false));
		},
		isHasPage() {
			return this.product.pages !== undefined && this.product.pages.length > 0;
		},
		isShowMarketingKit() {
			return this.user && this.product.marketing_kit !== undefined && !Array.isArray(this.product.marketing_kit);
		},
		isShowMarketingKits() {
			return this.user && Array.isArray(this.product.marketing_kit) && this.product.marketing_kit.length > 0;
		},
		isCODEnabled() {
			return this.product?.payments.findIndex(payment => payment === 'cod') !== -1;
		},
		isLpEnabled() {
			return this.product?.pages?.length > 0 ?? false;
		},
		isMarketingKitEnabled() {
			return this.product?.marketing_kit?.visible ?? false;
		},
		tableData() {
			const data = duplicateVar(this.productVariations?.table?.data);

			return data;
		},
	},
	mounted() {
		this.descriptionHeight = this.$refs?.description?.clientHeight;
	},
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/modules/_variables.scss';

::v-deep .slick-arrow:before {
	color: #2f3241;
	opacity: 1;
}

.slick-current .img-thumb {
	border: 2px solid $color__primary;
}

/* button.slick-arrow.slick-prev {
	left: -20px;
	}

	button.slick-arrow.slick-next {
	right: -20px;
	} */

.dropship-product-preview {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-top: 1px;
	font-size: 1rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

img.img-thumb {
	width: 100%;
	padding: 0px;
	border-radius: 8px;
	// max-height: 100px;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	background-color: #f3f3f3;
	border: 1px solid #dfdfdf;
}

img.img-main {
	width: 100%;
	border-radius: 8px;
	// max-height: 500px;
	background-color: #f3f3f3;
	aspect-ratio: 1 / 1;
	object-fit: contain;
	border: 1px solid #f0f0f0;
}

.details {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
}

.product-title,
.price,
.sizes,
.colors {
	/* text-transform: UPPERCASE; */
	font-weight: bold;
}

.price span {
	color: #ff9f1a;
}

.price {
	font-size: 24px;
	font-weight: 600;
	line-height: 32px;
	text-align: left;

}

.product-title,
.product-description {
	margin-bottom: 15px;
}

.capital-price {
	font-size: 14px;
	line-height: 22px;
	text-align: left;
}

.detail-title {
	font-size: 14px;
	line-height: 30px;
	text-align: left;
}

.stock {
	margin-bottom: 2px;
	margin-bottom: 4px;
	color: red;
	font-size: 0.9rem;
}

.subtitle span {
	font-weight: bolder;
}

.product-title {
	margin-top: 0;
}

.tooltip-inner {
	padding: 1.3em;
}

ul {
	list-style-type: none;
	padding-inline-start: 0px;
}

li ul {
	padding-inline-start: 20px;
}

.read {
	overflow: hidden;
	transition: all 0.3s;
}

.read-less {
	height: 210px !important;
	overflow: hidden;
}
</style>
<style lang="scss" scoped>
.table th, .table td {
    border-bottom: 0px solid #dee2e6;
}
.row {
	margin: 0;
}
.product-dropship-modal .modal-container {
	border-radius: 16px;
}

.product-dropship-modal .modal-footer {
	background-color: transparent;
}

.product-dropship-modal .modal-header {
	background-color: transparent;
	border-bottom: none;
	padding: 2px 5px;
}
.product-title {
	color: #414756;
	font-size: 28px;
	font-weight: 700;
	line-height: 34px;
	letter-spacing: 0em;
	text-align: left;
}
.divider {
	border-bottom: 1px solid #D9DADD;
	width: 100%;
	height: 1px;
}

.variant-info {
	font-size: 15px;
	line-height: 18px;
	text-align: left;
}

.nav-tabs .nav-link {
	background-color: transparent;
	border-top-left-radius: unset;
	border-top-right-radius: unset;
	border-color: unset;
    border-right-color: unset;
	border: none;
}

.nav-tabs .nav-link.active {
	color: $primary_color;
	border-bottom: 2px solid $primary_color;
}
.img-thumb-box {
	padding: 3px;
	cursor: pointer;
}

.product-aggregate {
	font-size: 12px;
}

@media only screen and (max-width: 991px) {
	.product-aggregate li {
		list-style: none;
	}
}

.first-aggregate {
	list-style: none;
}

.sale-price {
	text-decoration: line-through;
	color: #929292;
	font-size: 12px;
}

.percent-off {
	background-color: #FFDBE2;
	color: #F94D63;
	font-size: 10px;
}
</style>
